import { render, staticRenderFns } from "./ContextItem.vue?vue&type=template&id=1f648ffe&"
import script from "./ContextItem.vue?vue&type=script&lang=js&"
export * from "./ContextItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports